<script>
   /**************************************************************/
   /* Svelte component for ScoresPlot settings                   */
   /**************************************************************/

   import { Container, CompSelector } from '../controls';

   export let params;
   export let model;
   export let res;

   let comp1 = 1;
   let comp2 = model.ncomp > 1 ? 2 : 1;

   $: params = {
      'comp': [comp1, comp2],
   }
</script>

<Container label="">
<p class="title">Scores</p>
</Container>

{#if model && res}
<CompSelector bind:value={comp1} label='PC for x-axis' {model} />
<CompSelector bind:value={comp2} label='PC for y-axis' {model} />
{/if}

